import EventIcon from '@mui/icons-material/Event';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ArrayInput, BooleanField, BooleanInput, Create, Datagrid, Edit, EditButton, FormTab, List, NumberField, NumberInput, Show, ShowActions, SimpleFormIterator, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import OptionReferenceField from 'utils/GeneratedRaReference/OptionReferenceField';
import OptionReferenceInput from 'utils/GeneratedRaReference/OptionReferenceInput';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import FileManagerModalInput from 'utils/react-admin/inputs/FileManagerModalInput';
// import { GrapesjsInputButton } from 'utils/react-admin/inputs/GrapesjsInput';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import TinyMCEInput from 'utils/react-admin/inputs/TinyMCEInput';
import { Permissions } from '../../ra-php-crud-api-auth';
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <BooleanInput source="is_public" fullWidth />,
  <NumberInput source="position" fullWidth />,
  <OptionReferenceInput source="highlight_sub_category_id" fullWidth filter={{ option_type: 'highlight_sub_category' }} />,
  <TextInput source="title_en" fullWidth />,
  <TextInput source="title_tc" fullWidth />,
  <TextInput source="title_sc" fullWidth />,
  <TextInput source="sub_title_en" fullWidth />,
  <TextInput source="sub_title_tc" fullWidth />,
  <TextInput source="sub_title_sc" fullWidth />,
  <TextInput source="description_en" fullWidth />,
  <TextInput source="description_tc" fullWidth />,
  <TextInput source="description_sc" fullWidth />,
  <TextInput source="speaker_en" fullWidth />,
  <TextInput source="speaker_tc" fullWidth />,
  <TextInput source="speaker_sc" fullWidth />,
  <TextInput source="address_en" fullWidth />,
  <TextInput source="address_tc" fullWidth />,
  <TextInput source="address_sc" fullWidth />,
  <TextInput source="display_date" fullWidth />,
  <TextInput source="video_link" fullWidth />,
  <TextInput source="video_link_cn" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateIsPublic: any[] = [required()];
const validatePosition: any[] = [];
const validateHighlightSubCategoryId: any[] = [required()];
const validateTitleEn: any[] = [];
const validateTitleTc: any[] = [];
const validateTitleSc: any[] = [];
const validateSubTitleEn: any[] = [];
const validateSubTitleTc: any[] = [];
const validateSubTitleSc: any[] = [];
// const validateDescriptionEn: any[] = [];
// const validateDescriptionTc: any[] = [];
// const validateDescriptionSc: any[] = [];
const validateSpeakerEn: any[] = [];
const validateSpeakerTc: any[] = [];
const validateSpeakerSc: any[] = [];
const validateAddressEn: any[] = [];
const validateAddressTc: any[] = [];
const validateAddressSc: any[] = [];
const validateDisplayDate: any[] = [];
// const validateThumbnailFm: any[] = [];
// const validateCoverImageFm: any[] = [];
const validateVideoLink: any[] = [];
const validateVideoLinkCn: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.title_tc} (#${record.id})`}
          secondaryText={(record: any) => `${record.display_date}`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <BooleanField source="is_public" fullWidth />
            <NumberField source="position" fullWidth />
            <OptionReferenceField source="highlight_sub_category_id" fullWidth />
            <TextField source="display_date" fullWidth />
            {/* <TextField source="title_en" fullWidth /> */}
            <TextField source="title_tc" fullWidth />
            {/* <TextField source="title_sc" fullWidth /> */}
            {/* <TextField source="sub_title_en" fullWidth /> */}
            <TextField source="sub_title_tc" fullWidth />
            {/* <TextField source="sub_title_sc" fullWidth /> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <BooleanField source="is_public" fullWidth />
        <NumberField source="position" fullWidth />
        <OptionReferenceField source="highlight_sub_category_id" fullWidth />
        <TextField source="title_en" fullWidth />
        <TextField source="title_tc" fullWidth />
        <TextField source="title_sc" fullWidth />
        <TextField source="sub_title_en" fullWidth />
        <TextField source="sub_title_tc" fullWidth />
        <TextField source="sub_title_sc" fullWidth />
        <TextField source="description_en" fullWidth />
        <TextField source="description_tc" fullWidth />
        <TextField source="description_sc" fullWidth />
        <TextField source="speaker_en" fullWidth />
        <TextField source="speaker_tc" fullWidth />
        <TextField source="speaker_sc" fullWidth />
        <TextField source="address_en" fullWidth />
        <TextField source="address_tc" fullWidth />
        <TextField source="address_sc" fullWidth />
        <TextField source="display_date" fullWidth />
        <TextField source="video_link" fullWidth />
        <TextField source="video_link_cn" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  data.thumbnail_fm = ('string' === typeof data.thumbnail_fm) ? data.thumbnail_fm : (null === data.thumbnail_fm ? null : JSON.stringify(data.thumbnail_fm));;;
  data.image_array = ('string' === typeof data.image_array) ? data.image_array : (null === data.image_array ? null : JSON.stringify(data.image_array));;;
  data.cover_image_fm = ('string' === typeof data.cover_image_fm) ? data.cover_image_fm : (null === data.cover_image_fm ? null : JSON.stringify(data.cover_image_fm));;;

  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean}) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><BooleanInput source="is_public" fullWidth validate={validateIsPublic} /></Grid>
          <Grid item xs={6}><NumberInput source="position" fullWidth validate={validatePosition} /></Grid>
          <Grid item xs={12}><OptionReferenceInput source="highlight_sub_category_id" fullWidth filter={{ option_type: 'highlight_sub_category' }} validate={validateHighlightSubCategoryId} /></Grid>
          <Grid item xs={4}><TextInput source="title_en" fullWidth validate={validateTitleEn} /></Grid>
          <Grid item xs={4}><TextInput source="title_tc" fullWidth validate={validateTitleTc} /></Grid>
          <Grid item xs={4}><TextInput source="title_sc" fullWidth validate={validateTitleSc} /></Grid>
          <Grid item xs={4}><TextInput source="sub_title_en" fullWidth validate={validateSubTitleEn} /></Grid>
          <Grid item xs={4}><TextInput source="sub_title_tc" fullWidth validate={validateSubTitleTc} /></Grid>
          <Grid item xs={4}><TextInput source="sub_title_sc" fullWidth validate={validateSubTitleSc} /></Grid>
          <Grid item xs={12}><TinyMCEInput source="description_en" /></Grid>
          <Grid item xs={12}><TinyMCEInput source="description_tc" /></Grid>
          <Grid item xs={12}><TinyMCEInput source="description_sc" /></Grid>
          <Grid item xs={4}><TextInput source="speaker_en" fullWidth validate={validateSpeakerEn} /></Grid>
          <Grid item xs={4}><TextInput source="speaker_tc" fullWidth validate={validateSpeakerTc} /></Grid>
          <Grid item xs={4}><TextInput source="speaker_sc" fullWidth validate={validateSpeakerSc} /></Grid>
          <Grid item xs={4}><TextInput source="address_en" fullWidth validate={validateAddressEn} /></Grid>
          <Grid item xs={4}><TextInput source="address_tc" fullWidth validate={validateAddressTc} /></Grid>
          <Grid item xs={4}><TextInput source="address_sc" fullWidth validate={validateAddressSc} /></Grid>
          <Grid item xs={6}><TextInput source="display_date" fullWidth validate={validateDisplayDate} /></Grid>
          <Grid item xs={12}><FileManagerModalInput source="thumbnail_fm" mode={'image'} /></Grid>
          <Grid item xs={12}>
            <ArrayInput source="image_array" fullWidth>
              <SimpleFormIterator fullWidth sx={{ "& ul": { display: 'grid', gridTemplateColumns: '25% 25% 25% 25%', } }}>
                <FileManagerModalInput source="image" mode={'image'} />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
          <Grid item xs={12}><FileManagerModalInput source="cover_image_fm" mode={'image'} /></Grid>
          <Grid item xs={6}><TextInput source="video_link" fullWidth validate={validateVideoLink} /></Grid>
          <Grid item xs={6}><TextInput source="video_link_cn" fullWidth validate={validateVideoLinkCn} /></Grid>
        </GridWrapper>
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: EventIcon,
}

export default Resource;
